import { Injectable } from "@angular/core";
import { ApiService } from "../../api/api.service";
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GroupService {

  protected endpoint?: string

  constructor(private apiService: ApiService) {
    this.endpoint = 'rate-manager/provider'
  }

  cleanPayload (rawPayload: any) {
    return Object.fromEntries(
      Object.entries(rawPayload).filter(([_, v]) => v !== null)
    );
  }

  async getGroups(payload: Record<string, any> = {}) {
    payload = this.cleanPayload(payload);

    const response: any = await firstValueFrom(
      this.apiService.get(`${this.endpoint}/rates-groups`, payload, true)
    );

    // Extract actual data array (handles APIs that wrap in `data`)
    const data = response.data;

    // Transform into ng-select-friendly format
    return data.map((group: any) => ({
      value: group.id,
      label: group.name,
      description: group.description,
      provider: group.provider_name,
      ratesCount: group.rates_count,
    }));
  }

  async createNewGroup(payload: Record<string, any> = {}) {
    payload = this.cleanPayload(payload);
    return await firstValueFrom(
      this.apiService.post(`${this.endpoint}/rates-groups`, payload)
    );
  }

  async deleteGroup(id: number) {

    return await firstValueFrom(
      this.apiService.delete(`${this.endpoint}/rates-groups/${id}`)
    );
  }


}